<div class="w-visit" (click)="onSelectVesselVisit()">
	<div class="row h-100">
		<div class="col-auto flex-basis-180px" style="width: 180px">
			<h3 class="text-truncate">#{{ vesselVisit().id }}</h3>
			<div class="py-2 font-size-18 text-truncate">
				<b>{{ vesselVisit().vesselName }}</b>
			</div>
			<p>Vessel Type: <b>{{ vesselVisit().vesselTypeName }}</b></p>
			<p class="text-truncate">Marine Agency: <b>{{ vesselVisit().marineAgencyName }}</b></p>
			<p>IMO: <b>{{ vesselVisit().imo }}</b></p>
			<p>LOA: <b>{{ vesselVisit().loa }}</b></p>

			<!-- <div class="w-visit__status"
				 [ngClass]="vesselVisitStatusColour(vesselVisit().status)">
				<b>{{ vesselVisit().status }}</b>
			</div> -->

			<!-- <kendo-chip [fillMode]="'none'"
						[rounded]="'full'"
						[removable]="false"
						[selected]="false"
						[ngClass]="vesselVisitStatusColour(vesselVisit().status)"
						class="w-100 pointer-events-none">
				<b class="line-height-1 px-1 text-center w-100">{{ vesselVisit().status }}</b>
			</kendo-chip> -->
		</div>
		<div class="col w-visit__progress">
			<div class="w-visit__container">
				<pmis3-vessel-visit-stepper [vesselVisit]="vesselVisit()"
											[readonly]="disableStepper"></pmis3-vessel-visit-stepper>
			</div>
		</div>
	</div>
</div>